import { SignaturePadElement } from "../Signature/SignaturePadElement";
import "./CommentEditorElement.less";
import { CommentsStore } from './CommentsStore';
import { CameraActivator } from '../Camera/CameraActivator';
import { AttachmentStore } from "../Attachments/AttachmentStore";

export class CommentEditorElement extends HTMLElement { 
    static tag = "comment-editor";
    private _textarea: HTMLTextAreaElement;
    private _sendButton: HTMLButtonElement;
    private _signButton: HTMLButtonElement;
    private _takePictureButton: HTMLButtonElement;

    connectedCallback() { 
        this.innerHTML = this.view();
        
        this._sendButton = this.querySelector("button[name=send]");
        this._sendButton.addEventListener("click", this.onSend); 

        this._takePictureButton = this.querySelector("button[name=take-picture]");
        this._takePictureButton.addEventListener("click", this.onTakePicture);

        this._signButton = this.querySelector("button[name=sign]");
        this._signButton.addEventListener("click", this.onSign);

        this._textarea = this.querySelector("textarea[name=comment]");
        this._textarea.addEventListener("input", this.onInput);
    }

    disconnectedCallback() { 
        this.parentElement.style.removeProperty("--editor-height");
        this._sendButton.removeEventListener("click", this.onSend);
        this._textarea.removeEventListener("input", this.onInput);
        this._takePictureButton.removeEventListener("click", this.onTakePicture);
    }

    private onTakePicture = async () => { 
        await CameraActivator.instance.takePicture(this.getDeliveryIdentifier());
    }

    private _signaturePad: SignaturePadElement;

    private onSign = async () => { 
        this._signaturePad = new SignaturePadElement();
        this.parentElement.parentElement.appendChild(this._signaturePad);
        this._signaturePad.addEventListener("save", this.onSaveSignature, { once: true });
    }

    private getDeliveryType() : "Invoice" | "Return" { 
        if (this.getAttribute("delivery-type") === "Invoice")
            return "Invoice";
        else if (this.getAttribute("delivery-type") === "Return")
            return "Return";
        else
            throw new Error(`Invalid delivery type: ${this.getAttribute("delivery-type")}`);
    }

    private getDeliveryIdentifier() { 
        return {
            type: this.getDeliveryType(),
            invoiceNo: this.getAttribute("invoice-no"),
            orderNo: this.getAttribute("order-no"),
        };
    }

    private onSaveSignature = async (event: CustomEvent<string>) => { 
        const base64 = event.detail.replace("data:image/png;base64,", "");

        await AttachmentStore.instance.addAttachment(
            this.getDeliveryIdentifier(),
            base64,
            "png");

        this._signaturePad.removeEventListener("close", this.onCloseSignature);
        this._signaturePad.removeEventListener("save", this.onSaveSignature);
        this._signaturePad = undefined;
    }

    private onCloseSignature = () => { 
        this._signaturePad.removeEventListener("close", this.onCloseSignature);
        this._signaturePad.removeEventListener("save", this.onSaveSignature);
        this._signaturePad = undefined;
    }



    private onInput = () => { 
        
        this._textarea.style.height = "";
        const height = Math.min(this._textarea.scrollHeight, 200);
        this._textarea.style.height =  `${height}px`;
        this.parentElement.style.setProperty("--editor-height", `${height}px`);
        this.registerText();
    }

    private registerText = () => { 
        this.toggleAttribute("has-text", this._textarea.value.trim() !== "");
    } 

    private onSend = async () => { 
        this.toggleAttribute("busy", true);
        try {
            await CommentsStore.instance.addComment(this.getDeliveryIdentifier(), this._textarea.value);
            this._textarea.value = "";
            this.onInput();
        } finally { 
            this.toggleAttribute("busy", false);
        }
        
    }

    private view = () => `
        <textarea name="comment" placeholder="Add comment ..."></textarea>
        <button name="sign">${require("./Images/file-sign.svg")}</button>
        <button name="send">${require("./Images/send.svg")}</button>
        <button name="take-picture">${require("./Images/camera.svg")}</button>
    
    `;
}

customElements.define(CommentEditorElement.tag, CommentEditorElement);